module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-14-04ab28a346b7726c1e22165bbfac4f2a.png";